import { atom } from 'jotai';

export const unleashAtom = atom({
  loading: true,
});
